import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  errorMessage: {
    description: 'Vendor Invoices not selected error message',
    defaultMessage:
      'First, select the vendor invoices you would like to authorize.'
  },
  toBePaidErrorMessage: {
    description: 'To Be Paid tab error message',
    defaultMessage: 'First, select the vendor invoices you would like to pay.'
  },
  noStoreAvailable: {
    defaultMessage:
      'There are no Stores available. Please contact your System Administrator.',
    description: 'Error message no available store'
  },
  toDeclineErrorMessage: {
    description: 'To decline tab error message',
    defaultMessage:
      'First, select the vendor invoices you would like to decline.'
  },
  toggleLockErrorMessage: {
    description: 'Toggle Lock Failure Message',
    defaultMessage: '{num} invoice(s) failed to update their lock status.'
  },
  unauthorizedUserMessage: {
    description: 'Unauthorized user permissions denied message',
    defaultMessage:
      'You do not have permission to access AP Payments. Please contact your system administrator to request access to AP Payments.'
  }
});
